import { Typography } from '@mui/material';
import { formatDistanceToNow, format } from 'date-fns';
import EndorsementHighlight from './EndorsementHighlight';
import {
  EndorsementCardContainer,
  EndorsementCard as StyledEndorsementCard,
  EndorsementCardHeader,
  EndorsementCardContent,
} from './Endorsements.styles';

function EndorsementCard({ endorsement }) {
  return (
    <EndorsementCardContainer direction="row">
      <StyledEndorsementCard>
        <EndorsementCardHeader
          title={<Typography variant="h5">{endorsement.reviewer}</Typography>}
          subheader={
            <Typography variant="subtitle1">{endorsement.relation}</Typography>
          }
          action={
            <Typography variant="h6">{`Met in ${format(new Date(endorsement.metIn), 'MMM yyy')} (${formatDistanceToNow(new Date(endorsement.metIn))} ago)`}</Typography>
          }
        />
        <EndorsementCardContent>
          <EndorsementHighlight fullReview={true} endorsement={endorsement} />
        </EndorsementCardContent>
      </StyledEndorsementCard>
    </EndorsementCardContainer>
  );
}

export default EndorsementCard;
